import { Component, Input } from '@angular/core';

/**
 * Generated class for the EbitMarginDataTableComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'ebit-margin-data-table',
  templateUrl: 'ebit-margin-data-table.html'
})
export class EbitMarginDataTableComponent {
  @Input() currencyUnit: any = 'GBP';
  @Input() ebitMarginData: any = {};

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/ebit-margin-data-table/ebit-margin-data-table.ts